import React from 'react';
import { X } from 'lucide-react';

const PosV2Drawer = ({ open, title, subtitle, onClose, children, wide, modal }) => {
  if (!open) return null;

  if (modal) {
    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center p-4 sm:p-6 overflow-y-auto">
        <button type="button" className="absolute inset-0 bg-black/70" aria-label="Fermer" onClick={onClose} />
        <div className="relative w-full max-w-5xl my-4 bg-[#151820] border border-white/10 rounded-2xl shadow-2xl flex flex-col max-h-[calc(100vh-2rem)]">
          <div className="flex items-start justify-between gap-3 p-4 sm:p-5 border-b border-white/10 shrink-0">
            <div>
              <h2 className="text-lg sm:text-xl font-bold text-white">{title}</h2>
              {subtitle && <p className="text-xs text-gray-400 mt-1">{subtitle}</p>}
            </div>
            <button type="button" onClick={onClose} className="p-2 rounded-lg hover:bg-white/10 shrink-0 text-gray-300">
              <X size={20} />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto p-4 sm:p-5">{children}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <button type="button" className="absolute inset-0 bg-black/60" aria-label="Fermer" onClick={onClose} />
      <aside
        className={`relative h-full bg-[#151820] border-l border-white/10 shadow-2xl flex flex-col ${
          wide ? 'w-full max-w-2xl' : 'w-full max-w-md'
        }`}
      >
        <div className="flex items-start justify-between gap-3 p-4 border-b border-white/10">
          <div>
            <h2 className="text-lg font-bold text-white">{title}</h2>
            {subtitle && <p className="text-xs text-gray-400 mt-1">{subtitle}</p>}
          </div>
          <button type="button" onClick={onClose} className="p-2 rounded-lg hover:bg-white/10 text-gray-300">
            <X size={20} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">{children}</div>
      </aside>
    </div>
  );
};

export default PosV2Drawer;
